import React, { useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from "formik";
import StarRating from "../StarRating/StarRating";
import { RatingsSchema } from "../../schemas";
import { postReview } from "../../apiservices/ApiServices";
import Loader from '../Loader/Loader';
import { IoMdStarOutline, IoMdStarHalf, IoMdStar } from "react-icons/io";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const ReviewForm = (props) => {
    const [isLoading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const swiperRef = useRef(null);
    const [files, setFiles] = useState([]);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFiles(droppedFiles);
    };

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);
        handleFiles(selectedFiles);
    };

    const handleFiles = (fileList) => {
        // Filter for specific file types if needed
        const validFiles = fileList.filter(file =>
            file.type.startsWith('image/') || file.type === 'application/pdf'
        );

        setFiles(prev => [...prev, ...validFiles]);

        // Reset file input to allow selecting the same file again
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const removeFile = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.classList.add('dragover');
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.classList.remove('dragover');
    };

    const initialValues = {
        rating: 0,
        message: "",
    };

    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true);

        const formData = new FormData();
        formData.append('order_hash', props.OrderHash);
        formData.append('description', values.message);
        formData.append('rating', values.rating);

        if (files && files.length > 0) {
            Array.from(files).forEach((file) => {
                formData.append('media[]', file);
            });
        }
        try {
            const res = await postReview(formData);
            //props.toast.success(res.data.message);
            setLoading(false);
            resetForm();
            setFiles([]);
        } catch (error) {
            setLoading(false);
            props.toast.error(error.response.data.message);
        }
    };

    return (
        <div className="forms-boxs review">
            <div className='order-head'>
                <h1>Submit Your Review</h1>
            </div>
            <Formik initialValues={initialValues} validationSchema={RatingsSchema} onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                    <Form>
                        <div className="form-group">
                            <label>Rating:</label>
                            <Field name="rating" component={StarRating} />
                            <ErrorMessage name="rating" component="p" style={{ color: "red" }} />
                        </div>
                        <div className="form-group">
                            <label>Message:</label>
                            <Field
                                as="textarea"
                                name="message"
                                placeholder="Write your review..."
                                className="form-control"
                            />
                            <ErrorMessage name="message" component="p" style={{ color: "red" }} />
                        </div>
                        <div className="formsBox upload-container">
                            <div
                                className="drop-zone"
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                            >
                                <p>Drag & Drop Here</p>
                                <p>or</p>
                                <button
                                    type="button"
                                    onClick={() => fileInputRef.current?.click()}
                                    className="select-button btn btn-green"
                                >
                                    Select Files
                                </button>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*,.mp4"
                                    multiple
                                    onChange={handleFileSelect}
                                    style={{ display: 'none' }}
                                />
                            </div>

                            {files.length > 0 && (
                                <div className="file-list mt-3">
                                    <h6>Selected Files:</h6>
                                    <ul className="list-group">
                                        {files.map((file, index) => (
                                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                <span>
                                                    {file.name} ({file.type})
                                                </span>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => removeFile(index)}
                                                >
                                                    Remove
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <button type="submit" disabled={isSubmitting} className="btn btn-green">Submit</button>
                    </Form>
                )}
            </Formik>
            {props?.orderReview != '' ? (
                <div className='reviewList'>
                    <div className='ratings'>
                        {props?.orderReview?.rating == 1 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 1.5 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStarHalf className='h' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 2 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 2.5 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarHalf className='h' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 3 && (

                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarOutline className='o' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 3.5 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarHalf className='h' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 4 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarOutline className='o' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 4.5 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStarHalf className='h' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                        {props?.orderReview?.rating == 5 && (
                            <div className='ratingsStart'>
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <IoMdStar className='f' />
                                <span>{props?.orderReview?.rating}</span>
                            </div>
                        )}
                    </div>
                    <p>{props?.orderReview?.review_date}</p>
                    <p>{props?.orderReview?.description}</p>


                    {Array.isArray(props?.orderReview?.review_media) && (
                        <div className='medislides'>
                            <Swiper
                                ref={swiperRef}
                                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                                spaceBetween={0}
                                slidesPerView={5}
                                navigation
                                pagination={{ clickable: true }}
                                scrollbar={{ draggable: true }}
                                loop={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: false,
                                }}
                                breakpoints={{
                                    1200: { slidesPerView: 5 },
                                    1024: { slidesPerView: 4 },
                                    768: { slidesPerView: 4 },
                                    640: { slidesPerView: 3 },
                                    401: { slidesPerView: 3 },
                                    300: { slidesPerView: 2 },
                                }}
                                onMouseEnter={() => {
                                    swiperRef.current?.autoplay?.start();
                                }}
                                onMouseLeave={() => {
                                    swiperRef.current?.autoplay?.stop();
                                }}
                            >

                                {props?.orderReview?.review_media?.map((item, index) => (
                                    <SwiperSlide key={`thumb-${index}`}>
                                        <div className='reviewmediaboxs'>
                                            <div className='imagesboxs'>
                                                {item?.media_type == 'image' && (<img src={item?.media_url} alt='Review Image' title='Review Image' />)}
                                                {item?.media_type == 'video' && (<video controls><source src={item?.media_url} type="video/mp4" />Your browser does not support the video tag.</video>)}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </div>
            ) : null
            }

            {isLoading ? <Loader /> : null}
        </div >
    );
};

export default ReviewForm;
